<template>
  <div >
    <div class="fieldview-container flex" :style="getStyle" >
      <div class="draggable-field" ref="draggableField" title="Drag to edit the positions">
        <vue-draggable-resizable :resizable="false" :draggable="false" :parent="true"
          class-name="draggable"
          v-for="{position:element, firstName, lastName} in positionsView"
          :key="`${element.number}-${key}`"
          :w="dynamicSize"
          :h="dynamicSize"
          :x="element.convertedX"
          :y="element.convertedY"
        >
        <span class="element-title">{{element.number}}</span>
        <caption class="caption" style="white-space: nowrap">{{firstName? `${firstName.charAt(0)}. ${lastName}`:element.abbreviation}}</caption>
        </vue-draggable-resizable>

      </div>
    </div>
  </div>
</template>

<script>
import { loadingController, toastController } from "@ionic/vue";
import VueDraggableResizable from 'vue-draggable-resizable/src/components/vue-draggable-resizable.vue'
import _ from 'lodash';

export default {
  name: 'Pitch',
  components: {
    VueDraggableResizable
  },
  data() {
    return {
      key: 0,
      parent: undefined,
      dynamicSize: 25,
      background: 'https://d2uws44ru9bqpq.cloudfront.net/assets/floorball-field-green.svg'
    };
  },
  props: {
    positions: {
      type: Array,
      // default: () => [{"position":{"name":"Goalkeeper","abbreviation":"GK","number":"1","order":1,"type":"line-up","coordinate":{"x":43.38235294117647,"y":76.67910447761194},"convertedX":107.15441176470588,"convertedY":372.66044776119406}},{"position":{"name":"Left Defender","abbreviation":"LB","number":"2","order":2,"type":"line-up","coordinate":{"x":19.81132075471698,"y":65.12968299711815},"convertedX":48.93396226415094,"convertedY":316.53025936599425}},{"position":{"name":"Right Defender","abbreviation":"RB","number":"3","order":3,"type":"line-up","coordinate":{"x":67.27941176470588,"y":64.73880597014924},"convertedX":166.18014705882354,"convertedY":314.63059701492534}},{"position":{"name":"Midfielder","abbreviation":"cm","number":"4","order":4,"type":"line-up","coordinate":{"x":42.83018867924528,"y":47.358309317963496},"convertedX":105.79056603773586,"convertedY":230.1613832853026}},{"position":{"name":"Left Winger","abbreviation":"LW","number":"5","order":5,"type":"line-up","coordinate":{"x":7.7101649708584405,"y":26.875341363612527},"convertedX":19.044107478020347,"convertedY":130.6141590271569}},{"position":{"name":"Right Winger","abbreviation":"RW","number":"6","order":6,"type":"line-up","coordinate":{"x":78.79858657243817,"y":27.109515260323157},"convertedX":194.6325088339223,"convertedY":131.75224416517054}}],
      required: true
    },
    teamList: {
      type: Array,
      required: true
    },
    teamId: {
      type: Number,
      required: true
    },
    match: {
      type: Object,
      required: true
    },
  },
  mounted() {
    const {positions,teamList } = this;
    if (!positions) {
      return;
    }
    window.addEventListener('resize', this.onResize);
    // chech each position and assign coordinate if not exist
    this.positions.forEach((element) => {
      if (!element.position.coordinate) {
        // eslint-disable-next-line no-param-reassign
        element.position.coordinate = {
          x: 0,
          y: 0
        };
      }
      const positionToMerge = teamList.positions.find((pos) => pos.number === element.position.number);
      if (positionToMerge) {
        // eslint-disable-next-line no-param-reassign
        element.position.coordinate = positionToMerge.coordinate;
      }

    });
    loadingController.create({ message: "Loading..." }).then(loading => {
      loading.present();
      setTimeout(() => {
        // assign converted coordinate to each position
        loading.dismiss();
        this.parent = this.$refs.draggableField;
        this.dynamicSize = this.parent.offsetWidth ? this.parent.offsetWidth / 8 : 25;
        this.positions.forEach((element) => {
          // eslint-disable-next-line no-param-reassign
          element.position.convertedX = this.toPositionValue(element.position.coordinate.x, 'x');
          // eslint-disable-next-line no-param-reassign
          element.position.convertedY = this.toPositionValue(element.position.coordinate.y, 'y');
        });
        this.key++;
      }, 1000);
    });
  },
  computed: {
    getStyle() {
      return {
        backgroundImage: `url(${this.background})`
      };
    },
    positionsView() {
      return this.positions
        .filter((element) => element.position.type !== 'substitute');
    },

  },
  methods: {
    
    onResize() {
      const { offsetWidth, offsetHeight } = this.$refs.draggableField;
      if (offsetWidth && offsetHeight) {
        this.dynamicSize = offsetWidth / 8;
        this.positions.forEach((element) => {
          // eslint-disable-next-line no-param-reassign
          element.position.convertedX = this.toPositionValue(element.position.coordinate.x, 'x');
          // eslint-disable-next-line no-param-reassign
          element.position.convertedY = this.toPositionValue(element.position.coordinate.y, 'y');
        });
      }
    },
    toPositionValue(value, axis) {
      if (this.parent) {
        const offset = axis === 'x' ? this.parent.offsetWidth : this.parent.offsetHeight;
        return ((value / 100) * offset);
      }
      return value;
    },
    
  },
  watch:{
    // watch for offset width
    '$refs.draggableField.offsetWidth'(newValue) {
      if (newValue) {
        this.dynamicSize = newValue / 8;
        this.positions.forEach((element) => {
          // eslint-disable-next-line no-param-reassign
          element.position.convertedX = this.toPositionValue(element.position.coordinate.x, 'x');
          // eslint-disable-next-line no-param-reassign
          element.position.convertedY = this.toPositionValue(element.position.coordinate.y, 'y');
        });
      }
    }

  }
};
</script>

<style scoped>
.fieldview-container{
  margin-top:2.2rem;
    aspect-ratio: 2.9/4.985;
    padding: 12.5%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    border-radius: 20px;
    box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.5);
    max-height:100%;
    margin: 0 auto;
    background-color: transparent;
}
.draggable-field{
  position: relative;
  height: 100%;
  width: 100%;

}
.draggable{
  position: absolute;
  background-color: red;
  border-radius: 100%;
  border: 3.5px solid #fff;

}
.element-title{
  width: 100%;
  height: 100%;
  font-size: clamp(0.75rem, 3.5vmin, 1.25rem);
  color:#fff;
  display: flex;
  text-transform: uppercase;
  justify-content: center;
  align-items: center;
}
.caption{
  width: 100%;
  height: 100%;
  font-size: clamp(0.75rem, 3vmin, 1.25rem);
  color:#fff;
  display: flex;
  text-transform: uppercase;
  justify-content: center;
  align-items: center;
  margin-top:0.38vh
}
.draggable:hover{
  cursor: pointer;
  border: 0.2vw solid red;
  box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.5);
}
</style>
